import React, { useEffect, useState } from "react";
import logo from "../../resource/7.png";
import CommonFormFields from "./CommonFormFields";
import Swal from "sweetalert2";
import axios from "axios";
import apiClient from "@/api/client";

const PirikaraRequest = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    wtNumber: "",
    email: "",
    pirikara_type: "",
    ip_address: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setFormData((prevFormData) => ({
          ...prevFormData,
          ip_address: response.data.ip, // Set the IP address
        }));
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIP();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate First Name
    if (!formData.firstName) newErrors.firstName = "First Name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.firstName)) newErrors.firstName = "First Name should contain only letters, spaces, or hyphens";

    // Validate Last Name
    if (!formData.lastName) newErrors.lastName = "Last Name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.lastName)) newErrors.lastName = "Last Name should contain only letters, spaces, or hyphens";

    // Validate Mobile Number
    if (!formData.mobileNumber) newErrors.mobileNumber = "Mobile Number is required";
    else if (!/^\d{10}$/.test(formData.mobileNumber)) newErrors.mobileNumber = "Mobile Number should be 10 digits";

    // Validate Email
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Invalid email format";

    // Validate WT Number
    if (!formData.wtNumber) newErrors.wtNumber = "WhatsApp Number is required";
    else if (!/^\d{10}$/.test(formData.wtNumber)) newErrors.wtNumber = "WhatsApp Number should be 10 digits";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check the form for errors.",
      });
      return; // Stop execution if validation fails
    }

    setLoading(true);

    try {

      const apiRequestData = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        mobile_number: formData.mobileNumber,
        whatsapp_number: formData.wtNumber,
        email_address: formData.email,
        pirikara_type: formData.pirikara_type,
        ip_address: formData.ip_address,
      };

      const response = await apiClient.post('/create-pirikara-requests',
        apiRequestData
      );


      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Form submitted successfully!",
      });

      // Reset the form
       setFormData({
      firstName: "",
      lastName: "",
      mobileNumber: "",
      wtNumber: "",
      email: "",
      pirikara_type: "",
      ip_address: "",
    });
    } catch (error) {
      console.error("Error submitting form:", error);
      let errorMessage = "Something went wrong!";
      if (error.response) {
        errorMessage = error.response.data.message || "An error occurred while submitting the form.";
      } else if (error.request) {
        errorMessage = "No response from the server. Please try again later.";
      }
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-page dark-gold ">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Pirikara Request Form</h2>
          </div>
        </div>

        <p className="font-p mt-6">
          Please fill in the following details and we will contact you.
        </p>

        <CommonFormFields
          formData={formData}
          handleInputChange={handleInputChange}
          errors={errors}
        />

        <p className="font-p mt-5">
          Kindly specify the type of Pirikara you wish to donate to the Monastery. You may select your preferred items from the list provided on the webpage
        </p>

        <div className=" mt-5">
          <div className="form-item">
            <textarea
              type=""
              id="pirikara_type"
              name="pirikara_type"
              value={formData.pirikara_type}
              onChange={handleInputChange}
              rows="6"
            />
            <label htmlFor="pirikara_type"></label>
          </div>
        </div>

        <button type="submit" id="submitbtn" className="mt-5" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>

        <p className="font-p mt-5 pb-4">
          Thank you for your kind support. We will be in touch with you shortly.
        </p>
      </form>
    </div>
  )
}

export default PirikaraRequest